import memoize from 'lodash/memoize';
import { selectPagination } from 'redux/helpers/pagination';
import { createSelector } from 'reselect';

const getMemberFeed = ({ member: { feedByMemberId } }, memberId) => selectPagination(feedByMemberId, memberId, 'postIds');

const getMemberIdsForSearchField = ({ member: { searchFieldMembers } }) => searchFieldMembers || [];

const getMemberEntities = ({ entities: { members } }) => members;

const getMemberSelector = createSelector(
  [getMemberEntities],
  memberEntities => memoize(
    memberId => memberEntities[memberId],
  ),
);

const getMembersSelector = createSelector(
  [getMemberEntities],
  memberEntities => memoize(
    // Filter out undefined entries — member IDs can be stale after a member is deleted.
    memberIds => memberIds.map(memberId => memberEntities[memberId]).filter(Boolean),
  ),
);

const getMembersForSearchField = createSelector(
  [getMemberIdsForSearchField, getMemberEntities],
  memoize(
    (ids, entities) => ids.map(id => entities[id]),
    ids => ids.join('-'),
  ),
);

export default {
  getMemberFeed,
  getMemberSelector,
  getMembersSelector,
  getMemberEntities,
  getMemberIdsForSearchField,
  getMembersForSearchField,
};
